import { Injectable, NgZone } from "@angular/core";
import { Router } from "@angular/router";
import { OfficeJSGuardService } from "./officejs-guard.service";
import { OutlookService } from "./outlook/outlook.service";

@Injectable({
  providedIn: "root"
})
export class MailBoxService {
  // Selected mail trigger, scoped only inside this service

  /**
   * Office Trigger
   * Once the addin is pinned 'addHandlerAsync' will gets triggered based on user's mail selection
   * The output is published through updateTaskPaneUi()
   * itemChanged() is the event handler
   */
  constructor(
    private readonly officeJSGuardService: OfficeJSGuardService,
    private readonly router: Router,
    private readonly ngZone: NgZone,
    private readonly outlookService: OutlookService
  ) {
  }

  async initOfficeJS(): Promise<void> {
    console.log("<====================Initalizing OfficeJS====================>");
    await this.officeJSGuardService.canAccessOffice365();
    this.outlookService.mailbox.addHandlerAsync(Office.EventType.ItemChanged, this.itemChanged.bind(this));
  }

  private itemChanged(eventArgs: Office.EventType) {
    if (this.outlookService.mailboxItem) {
      // Emit custom event
      this.outlookService.itemChangedEvent.emit();
      this.updateTaskPaneUi();
    }
  }

  private updateTaskPaneUi() {
    this.ngZone.run(() => {
      const mailItem = this.outlookService.mailboxItem;
      if (mailItem && !mailItem.displayReplyForm) {
        this.router.navigateByUrl("/compose/compose-archive");
      } else {
        this.router.navigateByUrl("inbox/action");
      }
    });
  }
}
